/**
 * Lê uma variável de ambiente em RUNTIME, sem tratamento.
 *
 * `window.env` é escrito pelo `docker/env.sh` no start do container
 * (`static/js/env.js`, carregado antes do bundle). Ler por aqui — e nunca por
 * `process.env.REACT_APP_*` direto — é o que permite a mesma imagem Docker
 * servir vários municípios: o webpack substituiria o `process.env` por um
 * literal no build e o `-e` do `docker run` seria ignorado em silêncio.
 *
 * Use para valores OPCIONAIS ou que não são URL (identificadores, flags):
 * devolve `""` quando ausente, sem logar. Para URLs, use `getFullPathEnv`.
 */
export function getEnv(envKey: string): string {
  const env = (window as any).env ?? process.env;

  return env[envKey] ?? "";
}

export function getFullPathEnv(envKey: string, path?: string) {
  const rawUrl = getEnv(envKey);
  if (!rawUrl) {
    console.warn(`Variável de ambiente não encontrada: ${envKey}`);
    return "";
  }

  const apiUrl = rawUrl.replace(/\/+$/g, "");
  const pathSemBarra = path?.replace(/^\/+|\/+$/g, "");

  return [apiUrl, pathSemBarra].filter(Boolean).join("/");
}
